"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _en_US = _interopRequireDefault(require("./entries/en_US"));

var _zh_CN = _interopRequireDefault(require("./entries/zh_CN"));

var _fr_FR = _interopRequireDefault(require("./entries/fr_FR"));

var _ja_JP = _interopRequireDefault(require("./entries/ja_JP"));

var AppLocale = {
  en: _en_US.default,
  zh: _zh_CN.default,
  fr: _fr_FR.default,
  ja: _ja_JP.default
};
var _default = AppLocale;
exports.default = _default;